export const transformStates = states => states.map(item => ({ value: item.stateCode, label: item.stateName }))
